import React, { Component } from "react";
import {getTimeInIST, format_without_time, format_display_date, toInt, format_fancy_notime} from '../Utils';
import { WarehouseService } from "../Services/WarehouseService";
import moment from "moment";
import { ProductService } from "../Services/ProductService";
import { UserService } from "../Services/UserService";
import "../css/inventory_transactions.css"
import { ROLES } from "../Roles";
import {red, blue} from '@material-ui/core/colors';
import 'react-day-picker/lib/style.css';
import { withStyles, TableCell, TableRow, Typography, Table, IconButton, FormControl, Icon, Tooltip, MenuItem, InputLabel, Select, OutlinedInput, Grid, Paper, TablePagination, TableBody, Fab, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Chip, Fade, CircularProgress, Button } from "@material-ui/core";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DeleteIcon from '@material-ui/icons/Delete';
// import AutoCompleteSelection from "../components/AutoCompleteSelection_v2";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
// import EnhancedTableToolbar from "../components/EnhancedTableToolbar";
import EnhancedTableHead from "../components/EnhancedTableHead";
import { RowCountOptions } from "../Config";
import TransactionDetailsInformation from "../components/TransactionDetailsInformation";
import NewTransactionDialog from "../components/NewTransactionDialog";
import ItemSelection from "../components/ItemSelection";

const styles = theme =>({
    appBar: {
        position: 'relative',
        marginBottom: 10
    },

    fab: {
        margin: theme.spacing(1),
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        position: 'fixed', 
        zIndex: 2
    },
    
    root: {
        width: '100%',
        overflowX: 'auto',
        paddingTop : theme.spacing(1), 
        paddingLeft: theme.spacing(1), 
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    qtyField: {
        width: "40%",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            right: '100px',
            width: "10%",
            marginRight: 10
        },
        right: "22px"
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px',
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    },
    txn_details: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        float: "right",
        marginRight: theme.spacing(4)
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(0),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
        },
    },
    formControlLeft: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(4),
        },
    },
    card: {
        maxWidth: 600,
        minWidth: 300,
        minHeight: 184,
        margin: 5
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    tablecell: {
        fontSize: '12pt',
        padding: theme.spacing(2)
    },
    container: {
        paddingTop : theme.spacing(1)
    },
    redAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: red[500],
    },
    blueAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: blue[500],
    },
    formControlAutoComplete: {
        zIndex: 2,
        margin: theme.spacing(1),
        minWidth: 200,
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
    },
    row: {
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.background.default,
        },
    },
    instructions: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    button: {
        marginTop: theme.spacing(3),
        height: theme.spacing(7),
        float: 'left',
        marginLeft: theme.spacing(2),
    }, 
    tableWrapper: {
        height: 520,
        overflow: 'auto',
    },
    list: {
        width: '100%',
        height: 250,
        overflow: "auto"
    },
    summary: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    typography: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    details: {
        alignItems: 'center',
    },
    columnFilter: {
        marginTop: 5,
        flexBasis: '5%',
    },
    column: {
        flexBasis: '100%',
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2),
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    heading: {
        fontSize: theme.typography.pxToRem(18),
    }
});

class InventoryTransactions extends Component {

    constructor(props) {
      super(props);
      this.state = {
        startdate : moment().add(-1, 'month'),
        enddate: moment(),
        current_rows: [],
        numItemsPerPage: 10,
        currentPageNumber: 0,
        totalItems: 0,
        totalPages: 0,

        columns : [
            { id: 'index', numeric: false, disablePadding: true, label: 'Sl. No', sortable: false },
            { id: 'txn_date', numeric: false, disablePadding: true, label: 'Transaction Date', sortable: false },
            // { id: 'txn_type', numeric: false, disablePadding: true, label: 'Type', sortable: false  },
            { id: 'source_name', align: 'left', numeric: false, disablePadding: true, label: 'Source', sortable: false  },
            { id: 'chevron', numeric: false, disablePadding: true, label: '', sortable: false  },
            { id: 'destination_name', align: 'left', numeric: false, disablePadding: true, label: 'Destination', sortable: false  },
            { id: 'stock_type', align: 'left', numeric: false, disablePadding: true, label: 'Stock Type', sortable: false  },
            // { id: 'items', numeric: false, disablePadding: true, label: 'Items', sortable: false  },
            { id: 'qty', numeric: true, disablePadding: true, label: 'Quantity', sortable: false  },
            { id: 'actions', numeric: false, disablePadding: true, label: '', sortable: false  },
        ],
        message : '',
        order: "desc",
        orderBy: "txn_date",
        master_products: [],
        master_reasons: [],
        // master_txn_types: [{id: '-1',name: 'All Transaction Types'}, {id: 'INWARD',name: 'INWARD'},{id: 'OUTWARD', name: 'OUTWARD'}],
        master_stock_type: [{id: '-1',name: 'ALL'}, {id: 'FRESH',name: 'FRESH'}, {id: 'RETURN', name: 'RETURN'}],
        master_source: [],
        selected_source: "-1",
        selected_destination: "-1",
        // selected_txn_type: "-1",
        selected_stock_type: "-1",
        selected_reason: {},
        selected_product: {},
        product_name_rows: [],
        reasons_row: [],
        dialog_transaction: undefined,
        dialog_open: false,
        new_dialog_open: false,
        dialog_transaction_id: undefined,
        loading: false
      }
    }

    componentDidMount(){
        this.props.setTitle('Transactions');
        this.props.isLoading(true);
        this.setState({loading: true});
        this.fetchMasterData();
        this.fetchData(0, this.state.numItemsPerPage);
    }

    fetchMasterData = () => {
        // this.fetchTxnTypeFilter();
        this.fetchProductsFilter();
        this.fetchSourcesFilter();
        this.fetchStockTypeFilter();
        this.fetchReasons();
    }

    fetchStockTypeFilter = () => {
        let stock_type_rows = this.state.master_stock_type.map((type) => (
            <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
        ));
        this.setState({stock_type_rows});
    }

    handleStockTypeSelection = (e) => {
        this.setState({selected_stock_type: e.target.value}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    // fetchTxnTypeFilter = () => {
    //     let txn_type_rows = this.state.master_txn_types.map((txn_type) => (
    //         <MenuItem key={txn_type.id} value={txn_type.id}>{txn_type.name}</MenuItem>
    //     ));
    //     this.setState({txn_type_rows: txn_type_rows});
    // }

    // handleTxnTypeSelection = (e) => {
    //     this.setState({selected_txn_type: e.target.value}, () => this.fetchData(0, this.state.numItemsPerPage));
    // }

    fetchProductsFilter = () => {
        ProductService.getProductList()
        .then((data) => {
            let product_name_rows = data.products.filter(p => p.status !== -1).map((element) =>( 
                ({id: element.id, name: element.display_name ? element.display_name : element.name, value: element.display_name ? element.display_name : element.name, label: element.display_name ? element.display_name : element.name})
            ));   
            let selected_product = {id: "-1", name: "All Products", value: "-1", label: "All Products", unit: "-1"};
            product_name_rows.unshift(selected_product);
            this.setState({master_products: data.products, product_name_rows, selected_product});
            
        })
        .catch(error => {
            console.log(error);
            
        });
    }

    handleProductSelection = (product) => {
        this.setState({selected_product: product}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    fetchSourcesFilter = () => {
        Promise.all([WarehouseService.getWarehouseList(0, 999, "", "name", "asc"),  UserService.getAgentList()])
        .then((data) => {
            console.log(data);
            let source_names = [];
            let master_source = [];
            if(data[0] && data[0].warehouse.length > 0){
                source_names = source_names.concat(data[0].warehouse.map((w) => (
                    <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
                )));
                master_source = master_source.concat(data[0].warehouse);
            }
            if(data[1] && data[1].users.length > 0){
                source_names = source_names.concat(data[1].users.map((w) => (
                    <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
                )));
                master_source = master_source.concat(data[1].users);
            }
            let selected_source = <MenuItem key={"-1"} value={"-1"}>{"ALL"}</MenuItem>;
            source_names.unshift(selected_source);
            this.setState({master_source, source_names, selected_source : "-1", selected_destination: "-1"});
            
        })
        .catch(error => {
            console.log(error);
            
        });
    }

    handleSourceSelection = (e) => {
        this.setState({selected_source: e.target.value}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleDestinationSelection = (e) => {
        this.setState({selected_destination: e.target.value}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    fetchReasons = () => {
        WarehouseService.getWarehouseReasons()
        .then(data => {
            let reasons_row = data.reasons.map((element) =>( 
                ({id: element.code, name: element.description, value: element.description, label: element.description})
            ));
            let selected_reason = {id: "-1", name: "All", value: "-1", label: "All", unit: "-1"};
            reasons_row.unshift(selected_reason);
            data.reasons.unshift({code: '-1', description: "No Reason", ownership_id: null});
            this.setState({master_reasons: data.reasons, reasons_row, selected_reason});
        });
    }

    handleReasonSelection = (reason) => {
        this.setState({selected_reason: reason}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeStartDate = (date) => {
        console.log(date);
        this.setState({
            startdate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeEndDate = (date) => {
        this.setState({
            enddate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    fetchRow = (newCurrentPage) => {
        this.fetchPage(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    handleShow = (transaction_id) => {
        this.setState({ new_dialog_open: true, dialog_transaction_id: transaction_id });
    }

    fetchData = (start, numberItems) => {
        this.setState({loading: true});
        this.props.isLoading(true);
        let products = !this.state.selected_product || this.state.selected_product.id === "-1" ? null : this.state.selected_product.id;
        let reasons = !this.state.selected_reason || this.state.selected_reason.id === "-1" ? null : this.state.selected_reason.id;
        let source_id = this.state.selected_source === "-1" ? null : this.state.selected_source;
        let destination_id = this.state.selected_destination === "-1" ? null : this.state.selected_destination;
        // let txn_type = this.state.selected_txn_type === "-1" ? null : this.state.selected_txn_type;
        let stock_type = this.state.selected_stock_type === "-1" ? null : this.state.selected_stock_type;

        WarehouseService.getTotalCount("TRANSACTION", moment.utc(this.state.startdate).format(format_without_time), moment.utc(this.state.enddate).add("1", "day").format(format_without_time), products, source_id, destination_id, stock_type, reasons)
        .then((data) => {
            console.log(data);
            this.setState({
                totalItems: toInt(data.count), 
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1,
                current_rows: []
            });
            if(toInt(data.count) > 0){
                this.fetchPage(start, numberItems);
            } else {
                this.setState({loading: false});
                this.props.isLoading(false);
            }
        })
        .catch(error => {
            console.log(error);
        });
    }

    fetchPage = (start, numberItems) => {
        this.props.isLoading(true);
        let rows = [];
        let products = !this.state.selected_product || this.state.selected_product.id === "-1" ? null : this.state.selected_product.id;
        let reasons = !this.state.selected_reason || this.state.selected_reason.id === "-1" ? null : this.state.selected_reason.id;
        let source_id = this.state.selected_source === "-1" ? null : this.state.selected_source;
        let destination_id = this.state.selected_destination === "-1" ? null : this.state.selected_destination;
        // let txn_type = this.state.selected_txn_type === "-1" ? null : this.state.selected_txn_type;
        let stock_type = this.state.selected_stock_type === "-1" ? null : this.state.selected_stock_type;

        WarehouseService.getTransactions(start, numberItems, moment.utc(this.state.startdate).format(format_without_time), moment.utc(this.state.enddate).add("1", "day").format(format_without_time), products, source_id, destination_id, stock_type, reasons)
        .then((data) => {
            console.log(data);
            this.setState({data: data.transactions});
            if(data.transactions){
                data.transactions.forEach((txn, index) => {
                    rows.push(<TransactionDetails slno={index+1+(this.state.currentPageNumber * this.state.numItemsPerPage)} index={index+1} key={txn.transaction_id} txn={txn} {...this.props} showDetails={this.details} edit={this.edit} remove={this.remove}/>);
                });
                this.setState({
                    current_rows: rows
                });
            }
            this.props.isLoading(false);
            this.setState({loading: false});
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
            this.setState({loading: false});
        });
    }

    newTransaction = (e) => {
        if(e) {
            e.preventDefault();
        }
        // this.fetchExistingTransactions();
        this.handleShow(undefined);
    }

    remove = (e, transaction) => {
        e.preventDefault();
        this.props.showConfirmDialog("Remove Transaction?", undefined, () => {
            this.removeAPI(transaction.transaction_id);
            this.props.closeConfirmDialog();
        });
    }

    removeAPI(transaction_id){
        WarehouseService.removeTransaction(transaction_id, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
        .then((data) => {
            console.log(data);
            this.fetchData(0, this.state.numItemsPerPage);
            this.props.showSnackBar(`Removed transaction` , 'success');
        })
        .catch((error) => {
            this.props.showConfirmDialog("Could not transaction. Please try again later.", undefined, undefined);
        });
        
    }

    edit = (e, transaction) => {
        if(e){
            e.preventDefault();
        }
        this.handleShow(transaction.transaction_id);
    }
    
    details = (e, transaction) => {
        this.setState({dialog_transaction: transaction, dialog_open: true});
    }
    
    render() {
        let classes = this.props.classes;
        let { loading, startdate, enddate, selected_stock_type, selected_destination, selected_source, selected_product, selected_reason, message, dialog_transaction, dialog_open, new_dialog_open, dialog_transaction_id, master_source, master_products, master_reasons, master_stock_type } = this.state;
        return (
                <div className="Home" style={{marginTop: 32}}>
                    <Fade
                        in={loading}
                        style={{
                            transitionDelay: loading ? '10ms' : '0ms'
                        }}
                        unmountOnExit
                        >
                        <CircularProgress style={{position: "fixed", top: "50%", left: "50%", zIndex: 10}}/>
                    </Fade>
                    <Grid container justify="center" spacing={2}>
                        <Grid item xs={12} lg={12} xl={9}>
                            <ExpansionPanel style={{zIndex: 5}}>
                                <ExpansionPanelSummary
                                    expandIcon={<Icon>expand_more</Icon>}
                                    aria-controls="panel1c-content"
                                    id="panel1c-header"
                                >
                                    <div className={classes.columnFilter}>
                                        <Typography className={classes.heading}>Filters</Typography>
                                    </div>
                                    <div className={classes.column}>
                                        {<Chip className={classes.chip} label={`${startdate.format(format_fancy_notime)} - ${enddate.format(format_fancy_notime)}`}/>}
                                        {/* { selected_txn_type && <Chip className={classes.chip} label={`${ master_txn_types.filter(m => m.id === selected_txn_type)[0].name}`}/>} */}
                                        { selected_stock_type && <Chip className={classes.chip} label={`Stock: ${ master_stock_type.filter(m => m.id === selected_stock_type)[0].name}`}/>}
                                        { selected_source !== '-1' && <Chip className={classes.chip} label={`Source: ${ master_source.filter(m => m.id === selected_source)[0].name}`}/>}
                                        { selected_destination !== '-1' && <Chip className={classes.chip} label={`Destination: ${ master_source.filter(m => m.id === selected_destination)[0].name}`}/>}
                                        { selected_product && <Chip className={classes.chip} label={selected_product.name}/>}
                                        { selected_reason && selected_reason.name && <Chip className={classes.chip} label={`Reason: ${selected_reason.name}`}/>}
                                    </div>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails className={classes.details}>
                                    <Grid container justify="flex-start" alignItems="center">
                                        <Grid item xs={12} lg={12}>
                                            {/* <FormControl variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                                                <InputLabel
                                                    ref={ref => {
                                                    this.InputLabelRef = ref;
                                                    }}
                                                    htmlFor="outlined-txn_type-simple"
                                                >
                                                    Transaction Type
                                                </InputLabel>
                                                <Select
                                                    value={this.state.selected_txn_type}
                                                    onChange={this.handleTxnTypeSelection}
                                                    input={
                                                    <OutlinedInput
                                                        labelWidth={50}
                                                        name="Transaction Type"
                                                        id="outlined-txn_type-simple"
                                                    />
                                                    }
                                                >
                                                    {this.state.txn_type_rows}
                                                </Select>
                                            </FormControl> */}
                                            <FormControl 
                                                variant="outlined" 
                                                className={classes.formControl} 
                                                style={{ float: "left" }}>
                                                <InputLabel
                                                    ref={ref => {
                                                    this.InputLabelRef = ref;
                                                    }}
                                                    htmlFor="outlined-txn_type-simple"
                                                >
                                                    Stock Type
                                                </InputLabel>
                                                <Select
                                                    margin="dense"
                                                    value={this.state.selected_stock_type}
                                                    onChange={this.handleStockTypeSelection}
                                                    input={
                                                    <OutlinedInput
                                                        labelWidth={50}
                                                        name="Stock Type"
                                                        id="outlined-txn_type-simple"
                                                    />
                                                    }
                                                >
                                                    {this.state.stock_type_rows}
                                                </Select>
                                            </FormControl>
                                            <FormControl variant="outlined" className={classes.formControl} style={{ float: "left"}}>
                                                <InputLabel
                                                    ref={ref => {
                                                    this.InputLabelRef = ref;
                                                    }}
                                                    htmlFor="outlined-warehouse-simple"
                                                >
                                                    Source
                                                </InputLabel>
                                                <Select
                                                    margin="dense"
                                                    value={this.state.selected_source}
                                                    onChange={this.handleSourceSelection}
                                                    input={
                                                    <OutlinedInput
                                                        labelWidth={50}
                                                        name="Source"
                                                        id="outlined-source-simple"
                                                    />
                                                    }
                                                >
                                                    {this.state.source_names}
                                                </Select>
                                            </FormControl>
                                            <FormControl variant="outlined" className={classes.formControl} style={{ float: "left"}}>
                                                <InputLabel
                                                    ref={ref => {
                                                    this.InputLabelRef = ref;
                                                    }}
                                                    htmlFor="outlined-warehouse-simple"
                                                >
                                                    Destination
                                                </InputLabel>
                                                <Select
                                                    margin="dense"
                                                    value={this.state.selected_destination}
                                                    onChange={this.handleDestinationSelection}
                                                    input={
                                                    <OutlinedInput
                                                        labelWidth={50}
                                                        name="Destination"
                                                        id="outlined-warehouse-simple"
                                                    />
                                                    }
                                                >
                                                    {this.state.source_names}
                                                </Select>
                                            </FormControl>
                                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                                <DatePicker
                                                    disableToolbar
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    margin="dense"
                                                    label="From"
                                                    value={startdate}
                                                    onChange={this.handleChangeStartDate}
                                                    format='DD MMM YYYY'
                                                    maxDate={enddate}
                                                    className={classes.formControl}
                                                    style={{float: "left"}}
                                                />
                                                <DatePicker
                                                    disableToolbar
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    margin="dense"
                                                    label="To"
                                                    value={enddate}
                                                    onChange={this.handleChangeEndDate}
                                                    maxDate={moment()}
                                                    format='DD MMM YYYY'
                                                    className={classes.formControl}
                                                    style={{float: "left"}}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={12} lg={3}>
                                            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                                <ItemSelection
                                                    label='Product'
                                                    value={this.state.selected_product || null} 
                                                    optionLabel='name'
                                                    //labelTemplate={option => `${option.name} (Mobile: ${option.mobile})`}
                                                    options={this.state.product_name_rows} 
                                                    selected={this.handleProductSelection}/>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} lg={3}>
                                            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                                <ItemSelection
                                                    label='Reason'
                                                    value={this.state.selected_reason || null} 
                                                    optionLabel='name'
                                                    //labelTemplate={option => `${option.name} (Mobile: ${option.mobile})`}
                                                    options={this.state.reasons_row} 
                                                    selected={this.handleReasonSelection}/>
                                                {/* <AutoCompleteSelection
                                                    placeHolder="Reason"
                                                    onChange={this.handleReasonSelection}
                                                    name="Reason"
                                                    isMulti={false}
                                                    value={[this.state.selected_reason]}
                                                    options={this.state.reasons_row}/> */}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </Grid>
                        <Grid item xs={12} lg={12} xl={9}>
                            <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                                { !message &&
                                    <Paper className={classes.root} style={{width: "100%", paddingLeft: "5px", paddingRight: "5px"}}>
                                        {/* <EnhancedTableToolbar title={"Transactions"}/> */}
                                        <div className={classes.tableWrapper}>
                                            <Table className={classes.table} stickyHeader size="small" style={{textAlign: 'justify'}}>
                                                <EnhancedTableHead
                                                    order={this.state.order}
                                                    orderBy={this.state.orderBy}
                                                    onRequestSort={() => {}}
                                                    rows ={this.state.columns} />
                                                        <TableBody>
                                                            {this.state.current_rows}
                                                        </TableBody>
                                            </Table>
                                        </div>
                                        <TablePagination
                                            rowsPerPageOptions={RowCountOptions}
                                            component="div"
                                            count={this.state.totalItems}
                                            rowsPerPage={this.state.numItemsPerPage}
                                            page={this.state.currentPageNumber}
                                            backIconButtonProps={{
                                                'aria-label': 'Previous Page',
                                            }}
                                            nextIconButtonProps={{
                                                'aria-label': 'Next Page',
                                            }}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                    </Paper>
                                }
                        </Grid>
                    </Grid>
                    { (this.props.user.roles.includes(ROLES.STORE_INCHARGE) || this.props.user.roles.includes(ROLES.STORE_MANAGEMENT)) && master_source.length > 0 && master_products.length > 0 &&
                        <Fab onClick={this.newTransaction} color="primary" aria-label="Add" className={classes.fab}>
                            <Icon>add</Icon>
                        </Fab>
                    }
                    <TransactionDetailsInformation transaction={dialog_transaction} open={dialog_open} close={() => this.setState({dialog_open: false, dialog_transaction: undefined})}/>
                    <NewTransactionDialog open={new_dialog_open} transaction_id={dialog_transaction_id} master_sources={master_source} master_reasons={master_reasons} master_stock_type={master_stock_type} master_products={master_products} close={() => this.setState({new_dialog_open: false, dialog_transaction_id: undefined})} {...this.props} save={() => this.fetchData(0, this.state.numItemsPerPage)}/>
                </div>
        );
    }
}

class TransactionDetails extends Component {

    render(){
      const {txn, slno, showDetails, remove, edit, user} = this.props;
        return (
            <TableRow key={txn.id}>
                {/* <TableCell component="th" scope="row" align="center" padding='none'>
                    {txn.txn_type === 'INWARD' ? <Avatar className={classes.blueAvatar}>IN</Avatar> : <Avatar className={classes.redAvatar}>OUT</Avatar> }
                </TableCell> */}
                <TableCell component="th" scope="row" align="center" padding='none' style={{width: '5vw'}}>
                    <Typography variant="subtitle2">{slno}</Typography>
                </TableCell>
                <TableCell align="center"  padding='none'>{getTimeInIST(txn.txn_date).format(format_display_date)}</TableCell>
                {/* <TableCell align="center"  padding='none'><Typography variant="subtitle2"> {txn.txn_type === 'INWARD' ? <CallReceivedIcon color="primary" style={{verticalAlign: "bottom"}}/>  : <CallMadeIcon color="secondary" style={{verticalAlign: "bottom"}}/> }{txn.txn_type}</Typography></TableCell> */}
                <TableCell align="left"  padding='none'><Typography variant="subtitle2">{txn.source_name}</Typography></TableCell>
                {/* txn.source_type === 'WAREHOUSE' && txn.destination_type === 'WAREHOUSE' ? "secondary" :  */}
                <TableCell align="center"  padding='none' style={{width: '3vw', paddingRight: 16}}><ChevronRightIcon color={"primary"} style={{verticalAlign: "bottom"}}/></TableCell>
                <TableCell align="left"  padding='none'><Typography variant="subtitle2">{txn.destination_name}</Typography></TableCell>
                <TableCell align="left"  padding='none'><Typography variant="subtitle2" color={txn.stock_type === 'FRESH' ? "primary" : "secondary"}>{txn.stock_type_description}</Typography></TableCell>
                {/* <TableCell align="center"  padding='none'><Typography variant="subtitle2">{txn.item_count}</Typography></TableCell> */}
                <TableCell align="right"  padding='none'><Typography variant="subtitle2">{txn.total_qty}</Typography></TableCell>
                <TableCell align="right"  padding='none'>
                    <Button variant="text" color="primary" onClick={(e) => showDetails(e, txn)}>View Details</Button>
                    {
                        user.roles.includes(ROLES.ACCOUNTS_ADMIN, ROLES.ADMIN) &&
                        <Tooltip title="Edit Transaction">
                            <IconButton aria-label="edit" color="primary" onClick={(e) => edit(e, txn)}>
                                <Icon>edit_icon</Icon>
                            </IconButton>
                        </Tooltip>
                        
                    }
                    {
                        user.roles.includes(ROLES.ACCOUNTS_ADMIN, ROLES.ADMIN) &&
                        <Tooltip title="Delete">
                            <IconButton aria-label="delete" color="secondary" onClick={e => remove(e, txn)}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>   
                    }
                </TableCell>
            </TableRow>
        );
    }
}

export default withStyles(styles)(InventoryTransactions);